var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Refresh__Icn/40px/Refresh",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5649085,8.59355341 C25.1923255,8.59355341 30.5649085,13.9661364 30.5649085,20.5935534 C30.5649085,27.2209704 25.1923255,32.5935534 18.5649085,32.5935534 C14.924031,32.5935534 11.6618662,30.9720918 9.46113803,28.4118926 L9.39842804,28.3365534 L10.8181941,26.9176765 C10.8425613,26.9474895 10.8670973,26.9771592 10.8918005,27.0066841 C12.7261792,29.1991128 15.4826993,30.5935534 18.5649085,30.5935534 C24.087756,30.5935534 28.5649085,26.1164009 28.5649085,20.5935534 C28.5649085,15.0707059 24.087756,10.5935534 18.5649085,10.5935534 C15.9298489,10.5935534 13.46363,11.6178909 11.6223898,13.3957693 L14.147428,13.3962878 L14.147428,15.3962878 L8.14742804,15.3962878 L8.14742804,9.39628779 L10.147428,9.39628779 L10.1467146,12.0413173 C12.3644395,9.85662937 15.3624497,8.59355341 18.5649085,8.59355341 Z",
    id: ".._.._src_svg_Icn_40px_Refresh__Combined-Shape",
    transform: "scale(-1 1) rotate(45 0 -26.136)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.e3867eff2365a1a5a4625272db287d52.svg";
export { ForwardRef as ReactComponent };